export function extractFieldErrors(error: any): Record<string, string> {
  const output: Record<string, string> = {};

  if (
    error?.response?.data?.errors &&
    Array.isArray(error.response.data.errors)
  ) {
    for (const err of error.response.data.errors) {
      if (err.field && err.message) {
        output[err.field] = err.message;
      }
    }
  } else {
    // Optionally handle generic fallback error
    output._global = "An unexpected error occurred. Please try again.";
  }

  return output;
}
